import React, { PropTypes } from 'react';
import AvatarOrigin from 'react-avatar';
import axios from 'axios';
import { call } from 'redux-saga/effects';

const knownPrefixes = [
  'prof', 'dr', 'doctor', 'ms', 'mrs', 'mr'
]

class Avatar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
  }

  componentWillMount() {
    const {
      src
    } = this.props;
    try {
      axios.get(src).then(response => {
        if (response.status == 200)
          this.setState({ loaded: true });
      })
    } catch (e) {}
  }

  processedName = () => {
    const name = this.props.name;
    return ((name || '').match(/^(([Pp]rof|[Dd]r|[Dd]octor|[Mm]s|[Mm]rs|[Mm]r|[Pp]rofessor)\.?\s)*(.*)/) || [])[3] || name
  }

  render() {
    const {
      size,
      src,
      name
    } = this.props;
    return (
      <AvatarOrigin size={size} round={true} name={this.processedName()}
        {...(this.state.loaded ? { src } : {})}
      />
    )
  }
}

PropTypes.Avatar = {
  size: PropTypes.integer,
  name: PropTypes.string,
  src: PropTypes.string
}

export default Avatar;



/** WEBPACK FOOTER **
 ** ./src/components/Avatar/Avatar.jsx
 **/